import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useOrderStore } from "~/stores/use-order-store";
import { useRegisterStore } from "~/stores/use-register-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderSettings from "./order-settings";

export default function OrderSettingsDialog() {
  const { t } = useTranslation("common");

  const { orderSettingsOpen, setOrderSettingsOpen } = useRegisterStore();

  const { currentOrder } = useOrderStore();

  const handleDialog = (open: boolean) => {
    setOrderSettingsOpen(open);
  };

  return (
    <Dialog open={orderSettingsOpen} onOpenChange={handleDialog}>
      <DialogContent onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{t("Order.settings")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <OrderSettings
            order={currentOrder}
            onClose={() => setOrderSettingsOpen(false)}
          />
        </ScrollArea>
        <DialogFooter>
          <Button
            size="lg"
            variant="success"
            className="w-full text-xl"
            type="submit"
            form="order-settings"
          >
            {t("done")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
